import React, { Component } from "react";
import Sidenavigation from "../layouts/Sidenavigation";
import Topnavigation from "../layouts/Topnavigation";
import Content from "../sections/Customer-review/Content";
import Quickbar from "../layouts/Quickbar";

class Customerreview extends Component {
  render() {
    return (
      <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
        <Sidenavigation />
        <main className="body-content">
          <Topnavigation />
          <Content />
        </main>
        <Quickbar />
      </div>
    );
  }
}

export default Customerreview;
